










































































































































import { Component } from "vue-property-decorator";
import { BookingWizardModule } from "@/store/modules/bookingWizard";
import BookingRoleViewModel from "@/models/BookingRoles/BookingRoleViewModel";
import BookingWizardBookingRoleCreate from "@/components/BookingRoles/BookingWizardBookingRoleCreate.vue";
import BookingWizardBookingRoleEdit from "@/components/BookingRoles/BookingWizardBookingRoleEdit.vue";
import ShiftViewModel from "@/models/Shifts/ShiftViewModel";
import { VuetifyConfirmObject } from "vuetify-confirm";
import GiganautVueForm from "@/components/Shared/GiganautVueForm";

@Component({
  name: "BookingWizardRequirements",
  components: { BookingWizardBookingRoleCreate, BookingWizardBookingRoleEdit },
})
export default class BookingWizardRequirements extends GiganautVueForm {

  rolesFailedValidation = false;

  async validateForm() {
    if (BookingWizardModule.newBooking.roles.length === 0) {
      this.rolesFailedValidation = true;
      return true;
    }
    this.rolesFailedValidation = false;
    return false;
  }

  async deleteShift(bookingRole: BookingRoleViewModel, shift: ShiftViewModel) {
    if (bookingRole.shifts.length > 1) {
      bookingRole.shifts.splice(bookingRole.shifts.indexOf(shift), 1);
    }
  }

  async copyDown(bookingRole: BookingRoleViewModel, shift: ShiftViewModel) {
    //Only copy if there are shifts below this one
    if (bookingRole.shifts.length != bookingRole.shifts.indexOf(shift)) {
      for (
        let index = bookingRole.shifts.indexOf(shift) + 1;
        index < bookingRole.shifts.length;
        index++
      ) {
        const shiftToUpdate = bookingRole.shifts[index];
        shiftToUpdate.startAtTime = shift.startAtTime;
        shiftToUpdate.endAtTime = shift.endAtTime;
        shiftToUpdate.quantity = shift.quantity;
        shiftToUpdate.break = shift.break;
        shiftToUpdate.isPaidBreak = shift.isPaidBreak;
      }
    }
  }

  async deleteBookingRole(bookingRole: BookingRoleViewModel) {
    const options: VuetifyConfirmObject = {
      buttonTrueText: "DELETE",
      buttonFalseText: "CANCEL",
      buttonTrueColor: "primary",
      buttonFalseColor: "primary",
    };
    const result = await this.$confirm(
      "Are you sure you want to delete this role?",
      options
    );
    if (result) {
      await BookingWizardModule.removeNewBookingRole(bookingRole);
    }
  }

  get dates() {
    return BookingWizardModule.newBooking.dates;
  }

  set dates(value) {
    BookingWizardModule.updateNewBookingDates(value);
  }

  get breaks() {
    return BookingWizardModule.newBookingOptions.breaks;
  }

  get roles() {
    return BookingWizardModule.newBooking.roles;
  }

  get loading() {
    return BookingWizardModule.loading;
  }

  private headers = [
    { text: "Date" },
    { text: "Start" },
    { text: "End" },
    { text: "Quantity" },
  ];
}
